<app-banner [heading]="'ABOUT TAGORE GLOBAL SCHOOL'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= Features Section ======= -->
    <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-8">
            <img src="assets/img/about/school-building-1.jpg" class="img-fluid mb-5" alt="">
          </div>
          <div class="col-lg-4 pt-5 pt-lg-0">
            <h4>About TGS</h4>
            <p>
              Tagore Global School, Kurukshetra is a part of prestigious TAGORE GROUP OF SCHOOLS. 
			  At Tagore Global School, Kurukshetra , we believe in excellence. Due to exceptional hard work, 
			  our team has produced excellent results year after year. <br><br>Till date, we are moulding 
			  students into Top All India Rankers in different areas within the limiting constraints.
			  
			  The medium of instruction and first language is English.
			  
			</p>
			
          </div>
		 </div>
      </div>
    </section><!-- End Features Section -->
<!-- OUR BRANCH SECTION -->
<app-banner [heading]="'Our Branches'"></app-banner>
	    <!-- End Breadcrumbs -->	  		 
	<!-- ======= PIC. Section ======= -->
	<section class="events3">
      <div class="container" >

        <div class="row d-flex justify-content-between">
		
		   <div class="col-md-4 d-flex align-items-stretch">
            <div class="card mx-md-2 mx-lg-0">
              <div class="card-img">
                <img src="assets/img/about/tagorekkr.jpg" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h5 class="card-title"> TAGORE GLOBAL SCHOOL </h5>
                <p class="designation">SEC-29 GLOBAL CITY</p>
				        <p class="experience">KURUKSHETRA</p>
              </div>
            </div>
          </div>
		   <div class="col-md-4 d-flex align-items-stretch">
            <div class="card mx-md-2 mx-lg-0">
              <div class="card-img">
                <img src="assets/img/about/tagorepehowa.jpg" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h5 class="card-title"> TAGORE PUBLIC SCHOOL  </h5>
                <p class="designation">PEHOWA (KURUKSHETRA)</p>
				<p class="experience">HARYANA</p>
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card mx-md-2 mx-lg-0">
              <div class="card-img">
                <img src="assets/img/about/tagorepehowa2.jpg" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h5 class="card-title"> TAGORE BAL NIKETAN  </h5>
                <p class="designation">PEHOWA (KURUKSHETRA)</p>
				<p class="experience">HARYANA</p>
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card mx-md-2 mx-lg-0">
              <div class="card-img">
                <img src="assets/img/about/school-building-2.jpg" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h5 class="card-title"> TAGORE PUBLIC SCHOOL </h5>
                <p class="designation"> KAITHAL</p>
				<p class="experience">HARYANA</p>
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card mx-md-2 mx-lg-0">
              <div class="card-img">
                <img src="assets/img/about/tagorekuthar.jpg" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h5 class="card-title"> TAGORE VANASTHALI PUBLIC SCHOOL </h5>
                <p class="designation">KUTHAR (H.P.)</p>
				<p class="experience">(Residential)</p>
              </div>
            </div>
          </div>
		  		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card mx-md-2 mx-lg-0">
              <div class="card-img">
                <img src="assets/img/about/tagoresamrala.jpg" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h5 class="card-title"> TAGORE GLOBAL SCHOOL</h5>
                <p class="designation">SAMRALA (PUNJAB)</p>
				<p class="experience"></p>
              </div>
            </div>
          </div>
		    <div class="col-md-4 d-flex align-items-stretch">
            <div class="card mx-md-2 mx-lg-0">
              <div class="card-img">
                <img src="assets/img/about/tagoresahenwal.jpg" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h5 class="card-title"> TAGORE INTERNATIONAL SCHOOL </h5>
                <p class="designation">SAHENWAL (PUNJAB)</p>
				<p class="experience"></p>
              </div>
            </div>
          </div>
		    

	<!-- END OF OUR BRANCH SECTION --> 
    <section id="features">
      <div class="container">

            <h1>The Academic Programme : </h1>
			<h4>Pre-School (Kindergarten)</h4>
            <p>
              Our Early Childhood Programme emphasizes on child-centric, self directed
			  learning and is concerned with the child's intellectual progress as well
              as its social, emotional, creative and physical well being. <br>It provides the 
			  children with a rich and stimulating environment in which proper learning can occur .
			  We work :

            </p>
            <p>
              Through specially designed sensorial material, as children try to classify,compare and arrange objects in their environment.
            </p>
            <p>
              Through language experience: story telling, reading, role play, writing experience, animated videos, rhythm and rhyming process.
            </p>
			<p>
			Through counting, shape Identification, computing and comparing,tiny tots begin to grasp basic mathematical relationship.
			</p>
			<p>
			Through practical life experience ( shoe-tying, cleaning up, serving their snacks etc...)
            </p>
			<p>
			Through art and  craft , music and dance activities with specialists in fine arts.
			</p>
			<p>	Through movement activities during daily  fun games.</p>
      <p>
				In our early childhood programme, we adopt the way the children naturally learn.
				They learn best in a relaxed ambience, where they can freely and recreationally
				explore and implore their environment with joy and in a play way method.<br><br>
				The school provides spacious and airy smart AC classrooms with simple decor and colorful
				furniture, and the provision of the latest audio-visual teaching aids.
            </p>
			<p>
			Recently , we have adopted an Early Years Teaching Programme that is comparable to the best in the World.
			</p>
          </div>
		  <div>
		  <!--<div class="col-lg-6 wow fadeInUp pt-5 pt-lg-0"> -->
            <h4>Primary School (I-V)</h4>
            <p>
              The goal of the primary curriculum is to lay a strong educational foundation. It is broadly based 
			  and takes into account the fact that each one enters the formal education with different level 
			  of readiness. The curriculum is planned to develop in the students, a respect and love for
			  learning, while giving them the strong basic skills, which they will need, to continue their 
			  education. Emphasis is  laid on building up language skills in English. Through projects and by 
			  learning with hand, heart and head, the pupils will develop all aspects of their personality.
            </p>
			
          </div>
		   <!--<div class="col-lg-6 wow fadeInUp pt-5 pt-lg-0"> -->
           <div> <h4>Middle School(VI-VIII)</h4>
            <p>
              As students leave the elemantary grades and approach adolescence,they experience a growing sense 
			  of independence.Our school curriculum supports this developmental stage by encouraging students 
			  to look inward while also exploring the outer world in greater depth.They are asked to develop 
			  skills in critical thinking and creative problem solving,to analyse and synthesize.They also 
			  begin studying the rich literature of English and other languages.<br><br>The curriculum fosters the
			  development of skills for communication,intercultural understanding and global engagement.In 
			  this way,students cultivate an ability to think for themselves that will serve them well in 
			  Secondary and Higher Secondary school and beyond.
            </p>
			
          </div>
		   <!--<div class="col-lg-12 wow fadeInUp pt-5 pt-lg-0"> -->
           <div> <h4>High School(IX-X)</h4>
            <p>
              Our Secondary curriculum is learner-centric with school being a place where students would 
			  be acquiring various skills;building self-concept,sense of enterprise,aesthetic sensiblities
			  and sportsmanship. We envision the all-round development of students in consonance with  
			  the holistic approach to education and therefore emphasize integration of co-curricular
			  domain with curricular domain in an equitable manner.<br>It is planned in a manner to imbibe 
			  21st century learning,literacy and life skills.The school has focused to align curriculum
			  in a way so that children feel more connected to it and employ their learning in real 
			  life contexts. <br><br>
			  The other salient features are:
            </p>
			<p>Inculcate values and foster cultural learning and international understanding in an interdependent society.</p>
			<p>Promote inclusive education.</p>
			<p>Promote goal setting and lifelong learning.</p>
			<p>Equally emphasize Co-scholastic areas of Art education and Physical education.</p>
			<p>Enhance self awareness and explore innate potential.</p>
			<p>Encourage healthy competition  so as to be able to make their mark.</p>
			
          </div>
		  <!--<div class="col-lg-12 wow fadeInUp pt-5 pt-lg-0"> -->
           <div> <h4>Co-Curricular</h4>
            <p>
              Co-Curriculur Activities are organized throughout the year to add further to a child's personality
			  and to instill self confidence. These activities are organized through the house system and clubs. <br><br>Every 
			  academic session is marked with a number of Co-Curricular activities like Debates, Declamation,
			  Dance, Mono- acting, Quiz Competitions, Poetry, Recitation, Public Speaking, Poster making,
			  Rangoli Competition, Elocutions etc.
            </p>
			
          </div>
		  
		  <div class="col-lg-12  pt-5 pt-lg-0" >
            <h4>Sports</h4>
            <p>
              Sports is an integral part of TGS where a students has to choose at least two games to practice regularly  out of 
			  Cricket, Football, Volleyball,Athletics, Lawn Tennis , Basket Ball , Skating , Badminton, Table-Tennis, Carrom , Chess , Yoga etc. .
            </p>
			
          </div>
		  
        </section></div>
      </div>
    </section><!-- End Features Section -->
</main>